// Module 
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useLocation, Link, useNavigate } from 'react-router-dom';
import axios from 'axios'

// CSS
import '_Asset/css/User/Include/sideMenu.css'

// Component
import { subMenuList } from 'User/Component/MenuList';

// API
import { KmCatApi, KmListApi } from '_Route/Api'; 
import React from 'react';


/*========================================================================
* KM Sub Menu 재귀 컴퍼넌트
========================================================================*/
let subMenu;
const SubMenu = ({kmMenu, setKmMenu, callId, item, index}) => {
  
  const location = useLocation();
  const path = location.pathname;
  const pathGrp = path.split('/')[3]
  const pathId = path.split('/')[4]
  
  // 하위 메뉴 여부 체크
  const currentIdArr = [];  
  const lastMenu = [];

  subMenu = kmMenu.filter(key => key.km_parent === callId && key.km_parent !== key.km_id);
  subMenu.map(key => currentIdArr.push(key.km_id))
  currentIdArr.map(arr_id => 
    lastMenu.push(subMenu.filter(key => key.km_parent === arr_id))
  )


  /* ========================================================================
  * 새로고침시 현재 메뉴 및 상위 메뉴 Active 적용
  ======================================================================== */
  const [isActive, setIsActive] = useState(false)

  const fsActive = (curChild) => {
    if (curChild.km_id === pathId) {
      setIsActive(true);
    } else {
      const children = kmMenu.filter(key => key.km_parent === curChild.km_id && key.km_parent !== key.km_id)
      if(children.length !== 0) {
        children?.map(key => {
          fsActive(key)
        })
      }
    }
  }
  useEffect(() => {
    setIsActive(false)
    fsActive(item)
  }, [pathId])


  return (
    <li key={index}>
      <Link to={`/develop/apis-manual/${pathGrp}/${item.km_id}`} data-status={isActive} onClick={() => setIsActive(!isActive)} className={`${lastMenu.length !== 0 ? isActive && 'active' : item.km_id === pathId && 'active'} ${lastMenu.length === 0 ? 'last' : ''}`} >
        {
          lastMenu.length === 0 ?
          <span></span>
          :
          <i className={`icofont-rounded-${isActive ? 'down' : 'right'}`}></i>
        }
        {item.km_title}
      </Link>

      <ul>
        {isActive &&
          kmMenu.filter(key => key.km_parent === callId && key.km_parent !== key.km_id).map((key, i) => (
            <SubMenu key={i} kmMenu={kmMenu} setKmMenu={setKmMenu} callId={key.km_id} item={key} index={i} />
          )
        )}
      </ul>
    </li>
  )
}


/*========================================================================
* Side Menu List
========================================================================*/
const SideMenu = ({fixedState}) => {
  
  // Check Location 
  const location = useLocation();
  const path = location.pathname;
  const findPath = path.split('/')[1];
  const findMenu = path.split('/')[2];
  const findGrp = path.split('/')[3];
  
  // Use Translate Module 
  // const { t } = useTranslation()
  
  
  /*========================================================================
  * Side Menu Set Event
  ========================================================================*/
  const [menu, setMenu] = useState([]);
  const [kmMenu, setKmMenu] = useState([]);
  const [defaultMenu, setDefaultMenu] = useState([])
  const [defMenuState, setDefMenuState] = useState(findGrp ? true : false);

  const [sideState, setSideState] = useState(true);
  const sideMenuRef = useRef(null);
  

  // 현재 URL의 메뉴 설정
  const menuItms = () => {
    if (findPath === 'develop') {
      axios({
        url: KmCatApi,
        method: 'GET',
      })
      .then(res => {
        // console.log(res, "GET KM Category List Success!");

        const r = res.data.result
        let menuTemp = []
        r.map(key => {
          menuTemp.push({
            name: `${key.km_grp}${' Manual'}`,
            group: key.km_grp,
            path: `/develop/apis-manual/${key.km_grp}`
          })
        })
        setMenu(subMenuList[0][findPath].concat(menuTemp));
      })
      .catch(err => {
        console.error(err, "GET KM Category List Error...");
      })
    } else {
      if (subMenuList[0][findPath]?.length !== 0) {
        setMenu(subMenuList[0][findPath]);
      }
    }
  }

  useEffect(() => {
    if (findMenu === 'apis-manual') {
      if(findGrp && findGrp !== 'search') {
        setDefMenuState(true)
      } else {
        setDefMenuState(false)
      }
      axios({
        method: 'GET',
        url: KmListApi,
      })
      .then(res => {
        // console.log(res, "KM List GET Success!")
        
        const r = res.data.result
        setKmMenu(r);
        setDefaultMenu(r.filter(key => key.km_depth === 0 && key.km_grp === findGrp))
      })
      .catch(err => {
        console.error(err, "KM List GET Error...")
      })
    }
    menuItms();
  }, [location])


  return (
    <div className={`userSideMenu ${fixedState ? 'fixed' : ''} ${sideState ? 'active' : ''}`} ref={sideMenuRef}>
      <div className="menuTit develop">
        <h2>{findPath.charAt(0).toUpperCase() + findPath.slice(1)}</h2>
        <button type="button" className="icofont-rounded-left closeBtn" onClick={() => setSideState(!sideState)}></button>
      </div>

      <div className="menuList">
        {
          (!defMenuState || findMenu !== 'apis-manual') ?
          <ul className="mainMenu">
            {menu?.map((s, i) =>
              <li key={i}>
                <Link to={s.path} className={(s.path.includes(findMenu) && findMenu !== 'apis-manual') ? 'active' : ''} onClick={() => setDefMenuState(!defMenuState)}>{s.name}{s.group && <i className="icofont-arrow-right"></i>}</Link>
              </li>
            )}
          </ul>
          :
          <div className="subMenu">
            <Link to="/develop/apis-manual" className="prevTitle" onClick={() => setDefMenuState(!defMenuState)}><i className="icofont-arrow-left"></i>{`${findGrp} Manual`}</Link>
            <ul>
              {defaultMenu.map((key, i) => 
                <SubMenu key={i} kmMenu={kmMenu} setKmMenu={setKmMenu} item={key} index={i} callId={key.km_id} />
              )}
            </ul>
          </div>
        }
      </div>
    </div>
  )
}

export default SideMenu;
